/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getRankingWeeksDDBySeason = function (seasonId) 
{
    const endpoint = `/${seasonId}/rankings`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 


// WEBPACK FOOTER //
// ./src/components/pages/api/getRankingWeeksDDBySeason.js